var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4938 25.0001V24.9991H25.5001V15.8303C25.5001 11.3449 24.5344 7.88965 19.2907 7.88965C16.7699 7.88965 15.0782 9.27298 14.3876 10.5844H14.3146V8.3084H9.34277V24.9991H14.5199V16.7345C14.5199 14.5584 14.9324 12.4542 17.6271 12.4542C20.2824 12.4542 20.3219 14.9376 20.3219 16.874V25.0001H25.4938Z",
    fill: "#F5FCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.912598 8.30933H6.09593V25H0.912598V8.30933Z",
    fill: "#F5FCFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.50208 0C1.84479 0 0.5 1.34479 0.5 3.00208C0.5 4.65938 1.84479 6.03229 3.50208 6.03229C5.15937 6.03229 6.50417 4.65938 6.50417 3.00208C6.50312 1.34479 5.15833 0 3.50208 0V0Z",
    fill: "#F5FCFE"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.13eac042.svg";
export { ForwardRef as ReactComponent };